import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import LogRocket from "logrocket";
import Vue from "vue";

export function setupSentry() {
  Sentry.init({
    dsn: "https://88182e4a8a0e4c75a9e71c0118e3f7a8@sentry.io/1886893",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

export function setupLogRocket() {
  LogRocket.init("atlis/atlisio");

  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}
